import { Box, Button, Text } from "@wix/design-system";
import { GlobeSmall, FigmaSmall } from "@wix/wix-ui-icons-common";
import { type FC } from "react";
import { useTranslation } from "@wix/fe-essentials-standalone";
import { useRecreateButtons } from "./useRecreateButtons";
import { RecreateModal } from "./RecreateModal";
import { PAGE_AREA } from "../../../bi/constants";

export const RecreateButtons: FC = () => {
  const {
    isRecreateFromWebsiteOpen,
    isRecreateFromFigmaOpen,
    handleWebsiteModalClose,
    handleFigmaModalClose,
    handleWebsiteClick,
    handleFigmaClick,
    validateWebsiteUrl,
    validateFigmaUrl,
    figmaModalContent,
    websiteModalContent,
    handleGenerateWebsite,
    handleGenerateFigma,
    isMobile,
  } = useRecreateButtons();
  const { t } = useTranslation();

  return (
    <>
      <Box
        marginTop={4}
        gap={3}
        verticalAlign="middle"
        align="center"
        direction={isMobile ? "vertical" : "horizontal"}
      >
        <Text size="small" verticalAlign="middle">
          {t("landing.recreate.buttons.title")}
        </Text>
        <Box gap={2}>
          <Button
            skin="dark"
            priority="secondary"
            size="small"
            prefixIcon={<GlobeSmall />}
            onClick={handleWebsiteClick}
          >
            {t("landing.recreate.buttons.websiteUrl")}
          </Button>
          <Button
            skin="dark"
            priority="secondary"
            size="small"
            prefixIcon={<FigmaSmall />}
            onClick={handleFigmaClick}
          >
            {t("landing.recreate.buttons.figmaLink")}
          </Button>
        </Box>
      </Box>
      <RecreateModal
        isOpen={isRecreateFromWebsiteOpen}
        onGenerate={handleGenerateWebsite}
        onClose={handleWebsiteModalClose}
        validateUrl={validateWebsiteUrl}
        content={websiteModalContent}
        pageArea={PAGE_AREA.RECREATE_FROM_WEBSITE_MODAL}
        isMobile={isMobile}
      />
      <RecreateModal
        isOpen={isRecreateFromFigmaOpen}
        onGenerate={handleGenerateFigma}
        onClose={handleFigmaModalClose}
        validateUrl={validateFigmaUrl}
        content={figmaModalContent}
        pageArea={PAGE_AREA.RECREATE_FROM_FIGMA_MODAL}
        isMobile={isMobile}
      />
    </>
  );
};
